<div *ngIf="!cargando && sidebarLinks.length" class="row contenedor">
  <app-sidebar
    [sidebarLinks]="sidebarLinks"
    [selected]="sidebarLinks[0].id"
    class="col-12 col-md-2"
  ></app-sidebar>
  <app-panel-data
    [data]="newData"
    [defaultTittle]="sidebarLinks[0].tittle"
    class="arrgInfo"
    class="col contenido"
  ></app-panel-data>
  <br />
</div>
<under-construction
  *ngIf="!cargando && !sidebarLinks.length"
></under-construction>
<div class="loader" *ngIf="cargando">
  <mat-spinner></mat-spinner>
</div>
